import Flag from "./Flag";
import "./Flag.css";

export default Flag;
